// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import ConfirmDialog from "./src/turbo_confirm"

new ConfirmDialog()

import "./src/lazy_load_images"

import "./controllers"